import { createFileRoute } from '@tanstack/react-router';
import { MfaSmsWizard } from '../../components/auth/MfaSmsWizard';

export const Route = createFileRoute('/_authenticated/_layout/me/security/mfa-sms-setup')({
    component: () => <MfaSmsWizard />,
});
